<template>
  <div>
    <h2>Datos del Empleado</h2>
    <br />
    <ul>
      <li>
        Fecha y hora de aplicación:
        <b>{{date}}</b>
      </li>
      <li>
        Número de empleado
        <b>{{participant.work}}</b>
      </li>
      <li>
        Nombre Completo
        <b>{{participant.name}}</b>
      </li>
      <li>
        Puesto
        <b>{{participant.position}}</b>
      </li>
    </ul>
    <br />
    <ul>
      <li
        :key="'personal-data-option-' + index"
        v-for="(personalDataOption, index) in participant.personalData"
      >
        {{personalDataOption.optionName}}:
        <b>{{personalDataOption.option}}</b>
      </li>
    </ul>
    <br />
  </div>
</template>

<script>
export default {
  props: { participant: Object },
  computed: {
    date() {
      var date = new Date(this.participant.resolved);
      return `${date.getDate()}/${date.getMonth() +
        1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
    }
  }
};
</script>

<style>
</style>